<template>
  <div class="square-wrapper">
    <div class="square-spacer"></div>
    <div class="square-content">
      <div class="combook-binding-frame">
        <div
          class="combook-binding-content"
          :style="backgroundImageStyle(coverThumbnailUrl)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coverThumbnailUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    backgroundImageStyle(coverThumbnailUrl) {
      return {
        "background-image": `url(${coverThumbnailUrl})`
      };
    }
  }
};
</script>

<style scoped>
.square-wrapper {
  position: relative;
  width: 100%;
  cursor: default;
  background-color: #f8f8f5;
}

.square-wrapper .square-spacer {
  width: 100%;
  padding-bottom: 100%;
}

.square-wrapper .square-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.combook-binding-frame {
  position: absolute;
  width: 60.7%;
  height: 85.7%;
  left: calc(50% - (60.7% / 2) + 0.5px);
  top: calc(50% - (85.7% / 2));
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 1px;
}

.combook-binding-frame .combook-binding-content {
  width: 100%;
  height: 100%;
  background-position: center right;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
